import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Fragment } from 'react'

import { Cross, ErrorFace, SucessFace } from '../../assets/img'
// import { ParticlesAnim } from '../particles/particles'

// const particlesStyles = { position: 'static', width: '100px' }

const StatusPopup = ({
  tryAgain,
  isOpen,
  setIsOpen,
  className,
  status = '',
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <Transition.Child
          as={'div'}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 z-30 bg-black bg-opacity-50 "
            onClick={() => setIsOpen(false)}
          />
        </Transition.Child>
        <div
          className="fixed inset-0 overflow-y-auto z-4"
          aria-hidden="true"
          onClick={() => setIsOpen(false)}
        />

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="z-0 opacity-0 scale-95"
            enterTo="z-40 opacity-100 scale-100"
            leave="ease-in duration-300"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="z-40 flex items-center justify-center md:min-w-[400px] md:min-h-[400px]">
              {status && (
                <>
                  {status.split('-')[0] === 'info' ? (
                    <InfoContent
                      className={className}
                      setIsOpen={setIsOpen}
                      status={status}
                    />
                  ) : (
                    <StatusContent
                      className={className}
                      setIsOpen={setIsOpen}
                      status={status}
                    />
                  )}
                </>
              )}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

const StatusContent = ({ className, setIsOpen, status }) => {
  return (
    <div
      className={classNames(className, [
        'w-full h-full bg-black border-[0.3px] p-5 flex justify-center items-center border-solid border-[#AD945F] shadow-[0_4px_4px_rgba(0,0,0,0.5)] rounded-[17px] relative',
      ])}
    >
      <button className="absolute top-[3%] left-[3%]">
        <Cross className="text-[#00FFF0] " />
      </button>
      <div className="flex flex-col justify-center items-center">
        <div>{status === 'Sucess' ? <SucessFace /> : <ErrorFace />}</div>
        <div className="text-[#00FFF0] mt-5">
          {status === 'Sucess' ? 'Sucess!' : 'Error'}
        </div>
        <div className="mt-8">
          <button
            onClick={() => setIsOpen(false)}
            className="text-black bg-[#00FFF0] w-[150px] h-[35px] border-[0.3px] border-solid border-[#00FFF0] rounded-[5px]"
          >
            {status === 'Sucess' ? 'YAY!' : 'Try Again Later'}
          </button>
        </div>
      </div>
    </div>
  )
}

const InfoContent = ({ className, status }) => {
  const infoType = parseInt(status.split('-')[1])
  return (
    <div
      className={classNames(className, [
        'w-full h-full bg-black border-[0.3px] p-5 flex justify-center items-center border-solid border-[#AD945F] shadow-[0_4px_4px_rgba(0,0,0,0.5)] rounded-[17px] relative',
      ])}
    >
      <button className="absolute top-[3%] left-[3%]">
        <Cross className="text-[#00FFF0] " />
      </button>
      <div className="flex flex-col text-white justify-center items-center w-[280px]">
        {[dayOneTxt, dayTwoTxt, dayThreeTxt, rewardTxt].map((content, i) => {
          if (infoType - 1 === i)
            return (
              <div className="text-center" key={i}>
                <h3 className="mb-7">Epoch Day {i + 1}</h3>
                <div className="gap-[10px]">
                  {content.map((i, _) => (
                    <p className="mb-5" key={_}>
                      {i}
                    </p>
                  ))}
                </div>
              </div>
            )
          else {
            return <div key={i}></div>
          }
        })}
        {infoType !== 4 && (
          <div className="">
            <button
              onClick={() =>
                open(
                  `https://medium.com/@galaktikanft/galaktika-mission-gameplay-epoch-day-${
                    infoType +
                    '-' +
                    ['2567c4ca5247', '1fa9ab76bffe', 'b9387c748243'][
                      infoType - 1
                    ]
                  }`,
                  '_blank',
                )
              }
              className="text-black bg-[#00FFF0] w-[200px] h-[35px] border-[0.3px] border-solid border-[#00FFF0] rounded-[5px]"
            >
              Learn more on Medium
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

const dayOneTxt = [
  'The missions are in progress with crew and spaceships navigating across the galaxies!',
  'Mission success or failure will be revealed when they return on the end of Day 3.',
]

const dayTwoTxt = [
  'Select 1 mission to enter per civilization if you haven’t already done so on Day 1, then stake NFTs.',
  'No GLK can be staked on Day 2.',
  'Stake NFTs if missions have already been selected on Day 1.',
  'Civilization NFTs, Spark and Krystal are required. Gain extra Mission Power (MP) with Synergy and Special NFTs.',
]

const dayThreeTxt = [
  'The missions are in progress with crew and spaceships navigating across the galaxies!',
  'Mission success or failure will be revealed when they return on the end of Day 3.',
]
const rewardTxt = [
  'Any unclaimed rewards will later appear under My Stats.',
  '‘Start New Mission’ to enter missions on Day 1 or 2 of the next Epoch.',
]
export default StatusPopup
